div(v-if='slots.link' @click='logout' data-test='logout.slot')
  slot(name='link')
a.fp-link(v-else @click='logout' data-test='logout.link') {{ t('logout') }}
